export default __webpack_public_path__ + "postMock-1750955242157.html";